import React, { ReactNode } from "react";

import { ScrollContainerWrap } from "./ScrollContainer.styles";

interface Props {
  scrollStyle?: object;
  children: ReactNode;
}
export const ScrollContainer = ({ children, scrollStyle }: Props) => {
  return (
    <ScrollContainerWrap>
      <div className="inner-container">
        <div
          style={scrollStyle}
          className="scroll-area"
        >
          {children}
        </div>
      </div>
    </ScrollContainerWrap>
  );
};
